import { ACTIONS } from '../action/actionTypes'
import wpapi from 'wpapi';

export const WPAPI = ( state = {}, action ) => {
  switch ( action.type ) {
    case ACTIONS.ADD_WPAPI_KEY:
      return Object.assign( {}, state, {
        instance: new wpapi({ endpoint: action.init.url })
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducer/wpapi_reducer.js